import classNames from 'classnames'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setItineraryArrivalLater,
  setItineraryDate,
  setItineraryDepartureLater,
  setItineraryDepartureNow,
  setItineraryTime
} from '../../store/itineraryOptions/itineraryOptionsSlice'
import { selectItineraryTimeOptions } from '../../store/itineraryOptions/itineraryTimeOptions.selectors'
import {
  ARRIVAL_LATER,
  DEPARTURE_LATER,
  DEPARTURE_NOW
} from '../../store/itineraryOptions/itineraryTimeOptionsWhenTypes'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import DatePicker from '../genericComponents/DatePicker'
import TimePicker from '../genericComponents/TimePicker'
import checkmark from '../genericComponents/assets/checkmark.svg'
import T from '../i18n/T'
import OptionsDialog from '../itinerary/OptionsDialog'
import SVGIcon from '../svg/SVGIcon'
import useUIDisplay from '../ui/useUIDisplay'
import s from './ItineraryTimeOptionsDialog.less'

export const ItineraryTimeOptionsDialog = () => {
  const { isUIDisplayed } = useUIDisplay(UI_ELEMENTS.ITINERARY_TIME_OPTIONS_DIALOG)
  const { when, date, time } = useSelector(selectItineraryTimeOptions)
  const dispatch = useDispatch()

  const onDateChange = date => dispatch(setItineraryDate({ date }))
  const onTimeChange = time => dispatch(setItineraryTime({ time }))

  const values = [
    {
      key: DEPARTURE_NOW,
      labelKey: 'itinerary.options.date.leaving-now',
      datetime: false,
      action: () => dispatch(setItineraryDepartureNow())
    },
    {
      key: DEPARTURE_LATER,
      labelKey: 'itinerary.options.date.leaving-later',
      datetime: true,
      action: () => dispatch(setItineraryDepartureLater())
    },
    {
      key: ARRIVAL_LATER,
      labelKey: 'itinerary.options.date.arrival-at',
      datetime: true,
      action: () => dispatch(setItineraryArrivalLater())
    }
  ]

  return (
    <OptionsDialog isDisplayed={isUIDisplayed} title="itinerary.options.date.title">
      <ul className={s.list}>
        {values.map(({ key, labelKey, datetime, action }) => {
          const selected = when === key
          return (
            <li key={key} className={classNames(s.item, selected && s.active)} onClick={() => !selected && action()}>
              {selected && (
                <span className={s.coche}>
                  <SVGIcon url={checkmark} />
                </span>
              )}
              <span className={s.label}>
                <T id={labelKey} />
              </span>
              {datetime && selected && (
                <div className={s.datetime}>
                  <DatePicker className={s.date} value={date} onChange={onDateChange} />
                  <TimePicker className={s.time} value={time} onChange={onTimeChange} />
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </OptionsDialog>
  )
}

export default withEmptyFallbackErrorBoundary(ItineraryTimeOptionsDialog)
